/* jshint esversion: 6 */
// import 'external';

import $ from 'jquery';
import throttle from 'lodash/throttle';

export default class WindowResizer {

    constructor(options) {
        
        // this.defaults = {
        //     el: '.el',
        // };
        
        // this.opt = $.extend({}, this.defaults, options);
        
        this.functions = [];
    }
    
    init() {
        if (this.check()) {
            this.prepare();
            this.run();
        }
    }
    
    check() {
        return true; //$(this.opt.el).length;
    }
    
    prepare() {
        console.log( 'WindowResizer: prepare [' + $().jquery + ']' );
        
        this.$window = $(window);
        this.$document = $(document);
    }
    
    run() {
        console.log( 'WindowResizer: run [' + $().jquery + ']' );
        
        this.addResizeBinding();
    }
    
    addEvent(func, context) {
        this.functions.push({
            func,
            context,
        });
    }
    
    addResizeBinding() {
        
        let saveWindowWidth = () => {
            $('body').data('width', this.$window.width());
        }
        
        saveWindowWidth();
        
        this.debouncedResize = throttle(() => {
            // only horizontal resize
            if ($('body').data('width') === this.$window.width()) {
                return;
            }
            
            console.log( 'WindowResizer: run resize window events' );
            
            this.functions.forEach((f) => {
                f.func.apply(f.context);
            });
            
            // OR
            
            // for (let f of this.functions) {
            //     f.func.apply(f.context);
            // }
            
        }, 400, {
            leading: false,
            trailing: true,
        });
        
        $(window).on('resize', () => {
            this.debouncedResize();
        });
        
    }
}



// WEBPACK FOOTER //
// ./modules/window-resizer/js/window-resizer.js